import getOptimizedImageUrl, { LOCAL_URL_START } from '../helpers/getOptimizedImageUrl';

/**
 * Calculates the needed/optimal size for the optimization based on the node width and the pixel density of the device.
 *
 * @param {HTMLElement} node
 * @returns String
 */
const getOptimizedSource = node => {
    const source = Object.hasOwn(node.dataset, 'lazyloadSrc') ? node.dataset.lazyloadSrc : null;
    const sourceFormat = Object.hasOwn(node.dataset, 'lazyloadImageFormat') ? node.dataset.lazyloadImageFormat : null;

    const devicePixelRatio = window.devicePixelRatio > 1 ? window.devicePixelRatio : 1;
    const calculatedWidth = Math.ceil(node.offsetWidth * devicePixelRatio);

    let url = source;
    let optimizedSource;

    if (url.startsWith(LOCAL_URL_START)) {
        if (source.includes('?')) {
            url = source.substring(0, source.indexOf('?'));
        }
        optimizedSource = getOptimizedImageUrl(url, calculatedWidth);
    } else {
        optimizedSource = getOptimizedImageUrl(url, calculatedWidth);
    }

    if (sourceFormat !== null && sourceFormat.length) {
        optimizedSource = optimizedSource.includes('?')
            ? `${optimizedSource}&format=${sourceFormat}`
            : `${optimizedSource}?format=${sourceFormat}`;
    }

    return optimizedSource;
};

export default function init() {
    const lazyLoadElements = document.querySelectorAll('[data-lazyload]');

    const intersectionObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry && entry.target) {
                const image = getOptimizedSource(entry.target);
                const lazyLoadingType = entry.target.dataset.lazyload.toLowerCase();

                if (entry.isIntersecting) {
                    if (lazyLoadingType === 'background') {
                        entry.target.style.backgroundImage = `url("${image}")`;
                    } else if (lazyLoadingType === 'poster') {
                        entry.target.setAttribute('poster', image);
                    }

                    delete entry.target.dataset.lazyload;
                    delete entry.target.dataset.lazyloadSrc;
                    delete entry.target.dataset.lazyloadImageFormat;

                    intersectionObserver.unobserve(entry.target);
                }
            }
        });
    });

    lazyLoadElements.forEach(element => {
        intersectionObserver.observe(element);
    });
}
